export var KitItemType;
(function (KitItemType) {
    KitItemType[KitItemType["SALE"] = 1] = "SALE";
    KitItemType[KitItemType["RAW_GOOD"] = 2] = "RAW_GOOD";
})(KitItemType || (KitItemType = {}));
//# sourceMappingURL=kit-item-type.js.map